import type { Role } from '@/api/types'
import { can, type Capability } from '@/auth/rbac'

export interface NavItem {
  to: string
  label: string
  /** Capability required to see the item; undefined = visible to all authenticated users. */
  capability?: Capability
  icon: string // inline SVG path data (24x24)
}

export const NAV_ITEMS: NavItem[] = [
  {
    to: '/orders',
    label: 'Заказы',
    icon: 'M4 6h16M4 12h16M4 18h10',
  },
  {
    to: '/dashboard',
    label: 'Сводка',
    capability: 'dashboard.view',
    icon: 'M4 13h6V4H4v9Zm0 7h6v-5H4v5Zm10 0h6V11h-6v9Zm0-16v5h6V4h-6Z',
  },
  {
    to: '/routes',
    label: 'Маршруты',
    capability: 'routes.manage',
    icon: 'M6 3v12a3 3 0 0 0 3 3h6m0 0-3-3m3 3-3 3',
  },
  {
    to: '/assistant',
    label: 'Помощник',
    icon: 'M12 3a7 7 0 0 0-7 7c0 2 1 3.5 2 4.5V18h10v-3.5c1-1 2-2.5 2-4.5a7 7 0 0 0-7-7Zm-3 18h6',
  },
  {
    to: '/admin',
    label: 'Админ',
    capability: 'admin.users',
    icon: 'M12 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8Zm-7 8a7 7 0 0 1 14 0',
  },
]

export function navItemsFor(role: Role): NavItem[] {
  return NAV_ITEMS.filter((item) => !item.capability || can(role, item.capability))
}
